import gql from 'graphql-tag';
import { kmsClient } from '../../apollo';
import { useQuery } from '@apollo/react-hooks';
import { PublisherSettingsQuery, PublisherSettingsQueryVariables } from './__generated__/PublisherSettingsQuery';

export const PUBLISHER_SETTINGS_QUERY = gql`
  query PublisherSettingsQuery($id: ID!) {
    publisher(id: $id) {
      id
      name
      email
      active
      crmAccountId
      temporaryHandoff
      contentEnhancerEnabled
      enableAiImagesGeneration
      dashboardAccessRestricted
      enablePauseArticlesInKss
      showStoryUrlAndSpendStatusInKss
      pageLockedArticlesEnabled
      customUserAgent
      facebookPixelId
      lastSpentDate
      createdAt
      publisherFacebookAccounts {
        priority
        facebookAccount {
          id
          name
          accountId
          businessIdType
        }
        accountHasAds
      }
      googleAccount {
        googleAccountId
        accountName
        timeZone
      }
      billingCenter {
        id
        enabled
        instances
      }
      selfServiceSettings {
        enabled
      }
      ssoEnabled
      ssoConfiguration {
        idpEntityId
        idpSsoUrl
        idpCertificate
      }
      facebookPages {
        instagramAccountType
        instagramAccountId
        facebookPage {
          id
          name
          externalId
          newPageExperience
        }
      }
      accountManager {
        id
        email
      }
      temporaryAccountManager {
        id
        email
      }
      accountSupervisor {
        id
        email
      }
    }
  }
`;

export const usePublisherSettingsQuery = (variables: PublisherSettingsQueryVariables) => {
  return useQuery<PublisherSettingsQuery, PublisherSettingsQueryVariables>(PUBLISHER_SETTINGS_QUERY, {
    variables,
    client: kmsClient,
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true
  });
};
